import { render, staticRenderFns } from "./TpmAnalytics.vue?vue&type=template&id=70aa84d8"
import script from "./TpmAnalytics.vue?vue&type=script&lang=ts"
export * from "./TpmAnalytics.vue?vue&type=script&lang=ts"
import style0 from "./TpmAnalytics.vue?vue&type=style&index=0&id=70aa84d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports